export const nav = (isNavToggled,isPanelToggled)  => {
  
  const nav = document.querySelector(".js-nav");
  const btnToggleNav = document.querySelector(".js-nav-toggle");

  const init = () => {
    updateNavState();
    bind();
  };

  const bind = () => {

    if (btnToggleNav) {
      btnToggleNav.onclick = function (e) {
        e.preventDefault();
        e.stopPropagation();
        isNavToggled = !isNavToggled;
        updateNavState();
      };
    }

  };

  const updateNavState = () => {
    if (isNavToggled) {
      nav.setAttribute("aria-hidden", false);
      nav.setAttribute("data-state", "open");
      document.body.setAttribute("data-menu-open", "true");
      btnToggleNav.innerHTML = 'Close';
    } else {
      nav.setAttribute("aria-hidden", true);
      nav.setAttribute("data-state", "closed");
      document.body.setAttribute("data-menu-open", "false");
      btnToggleNav.innerHTML = "Menu";
    }
  };

  init();

};


